import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";
import WithAjax from "../common/helpers/WithAjax";
import TabList from "../common/helpers/TabList";
import { setJumbotronTitle } from "../../actions/common";
import { clearSkillVendor, fetchSkillVendorOverviewSuccess } from "../../actions/pages/skillvendor-page";

import SkillVendorOverview from "./SkillVendorOverview";
import DirectorProfile from "./profile/DirectorProfile";
import VoiceActorProfile from "./profile/VoiceActorProfile";
import TranslatorProfile from "./profile/TranslatorProfile";
import SingerProfile from "./profile/SingerProfile";
import AdaptorProfile from "./profile/AdaptorProfile";
import LyricistProfile from "./profile/LyricistProfile";
import EditorProfile from "./profile/EditorProfile";
import SoundEngineerProfile from "./profile/SoundEngineerProfile";
import BookerProfile from "./profile/BookerProfile";
import DevicesGrid from "./DevicesGrid";
import ProductionsGrid from "./ProductionsGrid";
import HistoryProfileStatusesGrid from "./HistoryProfileStatusesGrid";
import SkillVendorEditAdminMessagesTab from "./SkillVendorEditAdminMessagesTab";
import { PERMISSION_ADMINMESSAGES_READ } from "../../constants";
import { checkPermission } from "../common/functions/permissions";

const mapStateToProps = (state, ownProps) => ({
  overview: state.skillVendorPage.overview,
  isLoading: state.common.isLoading,
});
const mapDispatchToProps = (dispatch) => ({
  setJumbotronTitle(title) {
    dispatch(setJumbotronTitle(title));
  },
  clearSkillVendor() {
    dispatch(clearSkillVendor());
  },
  fetchSkillVendorOverviewSuccess(overview) {
    dispatch(fetchSkillVendorOverviewSuccess(overview));
  },
});

const SkillVendorEdit = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  lifecycle({
    componentDidMount() {
      let id = parseInt(this.props.match.params.id, 10);

      if (!Number.isInteger(id)) {
        return;
      }

      this.fetchSkillVendor();
    },
    componentDidUpdate(prevProps) {
      if (this.props.overview === null && !this.props.isLoading) {
        this.fetchSkillVendor();
      }
    },
    fetchSkillVendor() {
      let id = parseInt(this.props.match.params.id, 10);

      let url = "skillvendors/" + id;

      this.props.clearSkillVendor();
      this.props.ajax.get(url, true, (data) => {
        this.props.setJumbotronTitle(data.FullName);
        this.props.fetchSkillVendorOverviewSuccess(data);

        let contentItems = [
          {
            label: "Overview",
            link: "overview",
            content: <SkillVendorOverview skillVendorId={id} />,
          },
        ];
        for (var i = 0; i < data.ProfileTypes.length; i++) {
          let profileStatus = data.ProfileTypes[i].Status;

          let profileTypeKey = data.ProfileTypes[i].Key;
          let profileTypeLabel = (
            <span>
              {data.ProfileTypes[i].Label}
              <span className={`tab-label-status tab-label-status-${profileStatus.toLowerCase()}`}>({profileStatus.substring(0, 1)})</span>
            </span>
          );
          let profileContent;

          switch (profileTypeKey) {
            case "Director":
              profileContent = <DirectorProfile />;
              break;
            case "VoiceActor":
              profileContent = <VoiceActorProfile skillvendorId={id} />;
              break;
            case "Translator":
              profileContent = <TranslatorProfile />;
              break;
            case "Singer":
              profileContent = <SingerProfile skillvendorId={id} />;
              break;
            case "Adaptor":
              profileContent = <AdaptorProfile />;
              break;
            case "Lyricist":
              profileContent = <LyricistProfile />;
              break;
            case "Editor":
              profileContent = <EditorProfile />;
              break;
            case "SoundEngineer":
              profileContent = <SoundEngineerProfile />;
              break;
            case "Booker":
              profileContent = <BookerProfile />;
              break;
            default:
              profileContent = "";
          }

          if (profileContent) {
            contentItems.push({
              label: profileTypeLabel,
              link: profileTypeKey.toLocaleLowerCase(),
              content: profileContent,
            });
          }
        }

        contentItems.push({
          label: "Productions",
          link: "productions",
          content: <ProductionsGrid />,
        });
        // contentItems.push({
        //   label: 'Points',
        //   link: 'points',
        //   content: <PointsGrid />
        // })
        contentItems.push({
          label: "Devices",
          link: "devices",
          content: <DevicesGrid />,
        });
        contentItems.push({
          label: "Profiles history",
          link: "profilesHistory",
          content: <HistoryProfileStatusesGrid />,
        });

        if (checkPermission(PERMISSION_ADMINMESSAGES_READ)) {
          contentItems.push({
            label: "Messages",
            link: "adminMessages",
            content: <SkillVendorEditAdminMessagesTab skillVendorId={id} />,
          });
        }

        this.setState({
          contentItems,
        });
      });
    },
  })
);

export default WithAjax(SkillVendorEdit(TabList));
